var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2701 5.79621L14.6601 7.67221L10.2681 9.90821C10.1862 9.95393 10.0939 9.97792 10.0001 9.97792C9.90627 9.97792 9.81401 9.95393 9.73209 9.90821L5.34109 7.67221L1.73009 5.79621C1.6321 5.74662 1.54977 5.67084 1.49226 5.57727C1.43474 5.48371 1.4043 5.37604 1.4043 5.26621C1.4043 5.15638 1.43474 5.04871 1.49226 4.95515C1.54977 4.86159 1.6321 4.7858 1.73009 4.73621L9.74409 0.81121C9.82352 0.771283 9.91119 0.750488 10.0001 0.750488C10.089 0.750488 10.1767 0.771283 10.2561 0.81121L18.2701 4.73621C18.3681 4.7858 18.4504 4.86159 18.5079 4.95515C18.5654 5.04871 18.5959 5.15638 18.5959 5.26621C18.5959 5.37604 18.5654 5.48371 18.5079 5.57727C18.4504 5.67084 18.3681 5.74662 18.2701 5.79621Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34009 7.67236L1.73009 9.39536C1.6321 9.44495 1.54977 9.52074 1.49226 9.6143C1.43474 9.70786 1.4043 9.81554 1.4043 9.92536C1.4043 10.0352 1.43474 10.1429 1.49226 10.2364C1.54977 10.33 1.6321 10.4058 1.73009 10.4554L5.34009 12.3314L9.73209 14.5674C9.81401 14.6131 9.90627 14.6371 10.0001 14.6371C10.0939 14.6371 10.1862 14.6131 10.2681 14.5674L14.6591 12.3314L18.2701 10.4564C18.357 10.4033 18.4288 10.3288 18.4786 10.24C18.5284 10.1513 18.5546 10.0512 18.5546 9.94936C18.5546 9.84756 18.5284 9.74746 18.4786 9.65868C18.4288 9.5699 18.357 9.49541 18.2701 9.44236L14.6601 7.67236",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34009 12.3301L1.73009 14.0551C1.6321 14.1047 1.54977 14.1805 1.49226 14.274C1.43474 14.3676 1.4043 14.4753 1.4043 14.5851C1.4043 14.6949 1.43474 14.8026 1.49226 14.8961C1.54977 14.9897 1.6321 15.0655 1.73009 15.1151L9.73209 19.1801C9.81401 19.2258 9.90627 19.2498 10.0001 19.2498C10.0939 19.2498 10.1862 19.2258 10.2681 19.1801L18.2701 15.1151C18.357 15.062 18.4288 14.9875 18.4786 14.8988C18.5284 14.81 18.5546 14.7099 18.5546 14.6081C18.5546 14.5063 18.5284 14.4062 18.4786 14.3174C18.4288 14.2286 18.357 14.1541 18.2701 14.1011L14.6601 12.3311",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.abca62ade283a8a9f2c7b7e3ccb35f59.svg";
export { ForwardRef as ReactComponent };